module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00018-fs8.28f9ebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00018-fs8.png
// module id = 171
// module chunks = 0